<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12"><circle cx="6" cy="6" r="6" fill="#fff"/><path fill="#000" d="M4.542 7.734 2.646 5.868 2 6.498 4.542 9 10 3.63 9.359 3 4.542 7.734Z"/></svg>
</template>

<script>
export default {
  name: "CheckedPickup"
}
</script>